export const paymentAccordian = [
  {
   id:1, 
   name:"Pay Now"
},
{
  id:2,
  name:"Pay Later",
  subele:[{
    id:1,
    name:"Credit Card"
  }]
}];
